<template>
  <Modal class-name="vertical-center-modal" v-model="isService" title="客服二维码" width="300">
    <div class="form-wrapper">
      <div class="code-box">
        <div class="padding-t-10">微信扫一扫联系客服</div>
        <img :src="service_code" alt="">
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>

<script>
  import {
    Modal,
    Spin
  } from 'view-design'
  export default {
    name: "Service",
    components: {
      Modal,
      Spin
    },
    data: function() {
      return {
        isService: false,
        service_code: '',
        loading: false,
      }
    },
    methods: {
      init: function(isService, code) {
        this.loading = true
        this.service_code = code
        this.isService = isService
        this.loading = false
      },
    }
  }
</script>


<style scoped>
  .normal-font {
    color: #ff8622;
    font-size: 14px;
  }

  >>>.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  >>>.vertical-center-modal .ivu-modal {
    top: 0;
    width: 300px;
  }

  >>>.vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 12px 18px 12px 18px;
    text-align: right;
  }

  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .form-wrapper .code-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    color: #222222;
  }

  .form-wrapper .code-box img {
    margin-top: 19px;
    width: 122px;
  }

  .footer-wrapper .btn {
    display: inline-block;
    border-radius: 4px;
    margin-right: 10px;
    padding: 0px 15px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    vertical-align: middle;
    cursor: pointer;
  }

  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }

  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    color: #222222;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/official/set/modal/Service.vue